<template>
    <q-item>
        <q-item-section avatar v-if="isFileImage && isSmallSize">
            <q-avatar rounded>
                <q-img :src="file.public_url" :alt="file.title" />
            </q-avatar>
        </q-item-section>
        <q-item-section>
            <div class="row no-gutters items-start no-wrap" v-if="mode === 'r'">
                <div class="col">
                    <div :class="{'text-blue-grey-3': ! file.title}">
                        <a :href="file.public_url" target="_blank"
                           :download="downloadAttrValue">{{ file.title || 'Untitled' }}</a>
                    </div>
                    <div class="text-subtitle2" :class="{'text-blue-grey-3': ! file.description}">{{ file.description || 'No description provided' }}</div>
                </div>

                <div class="col-auto pl-3">
                    <q-btn v-if="! props.readOnly" size="sm" flat icon="mode_edit" @click="prepareEdit"/>
                </div>
            </div>
            <div class="" v-if="mode === 'w'">
                <q-form @submit="updateUpload(file.id)" >
                    <div class="row justify-content-end">
                        <q-btn type="submit" size="sm" flat icon="save" :loading="isSaveLoading" v-if="! isDeleteTriggered" />

                        <div v-if="! isSaveLoading">
                            <q-btn size="sm" flat icon-right="backspace" v-if="! isDeleteTriggered"
                                   @click="deleteUpload(file.id)"/>
                            <q-btn size="sm" :loading="isLoading" color="red" v-if="isDeleteTriggered"
                                   flat label="Delete? Press again to confirm"
                                   icon-right="backspace"
                                   @click="deleteUpload(file.id)"/>
                            <q-btn size="sm" v-if="isDeleteTriggered && ! isLoading" flat icon="clear"
                                   @click="isDeleteTriggered = false"/>
                            <q-btn size="sm" flat icon="clear" @click="mode = 'r'" v-if="! isDeleteTriggered"/>
                        </div>
                    </div>
                    <div>
                        <div>
                            <q-input v-model="fileName" label="Name" stack-label />
                        </div>
                        <div>
                            <q-input v-model="fileDescription" label="Description" stack-label />
                        </div>
                    </div>
                </q-form>
            </div>
            <div class="">
                <p class="mb-0">
                    <a class="small" target="_blank"
                       :href="file.public_url"
                       :download="downloadAttrValue"
                    >{{ file.file_name }}</a>
                </p>
                <p class="mb-0 text-muted">
                    <small>
                        {{ formatFileSize(file.file_size, 2) }}
                    </small>
                </p>
            </div>
        </q-item-section>
    </q-item>
</template>

<script setup>
import utils from "../blocks/_utils";

import {useQuasar} from "quasar";
import {computed, nextTick, ref} from "vue";
const {formatFileSize} = utils

const $q = useQuasar()
const props = defineProps({
    file: Object,
    readOnly: Boolean
})

const emits = defineEmits(['deleted','updated'])

const isDeleteTriggered = ref(false)
const isLoading = ref(false)
const isSaveLoading = ref(false)
const mode = ref('r')

const fileName = ref('')
const fileDescription = ref('')

const deleteBtnColor = computed(() => {
    return isDeleteTriggered.value ? 'red' : 'grey-7'
})
const deleteBtnLabel = computed(() => {
    return isDeleteTriggered.value ? 'Delete? Press again to confirm' : null
})

const prepareEdit = () => {
    fileName.value = props.file.title
    fileDescription.value = props.file.description

    nextTick(() => {
        mode.value = 'w'
    })
}

const deleteUpload = (id) => {

    if (! isDeleteTriggered.value) {
        isDeleteTriggered.value = true
        return
    }

    isLoading.value = true

    window['APIv2']._request(`contact/delete_upload/${id}`, {
        field: 'attachments',
    }, 'POST').then(() => {
        emits('deleted')
    }).catch((err) => {
        console.log(err)
    })
        .finally(() => {
            isLoading.value = false
        })
}

const updateUpload = (id) => {
    isSaveLoading.value = true

    window['APIv2']._request(`contact/update_upload/${id}`, {
        field: 'attachments',
        data: {
            title: fileName.value,
            description: fileDescription.value,
        },
    }, 'POST').then(() => {
        mode.value = 'r'
        emits('updated')
    }).catch((err) => {
        console.log(err)
    })
        .finally(() => {
            isSaveLoading.value = false
        })
}

const isFileImage = computed(() => {
    return props.file.content_type.startsWith('image')
})

const isSmallSize = computed(() => {
    return props.file.file_size < 1024 * 512
})

const downloadAttrValue = computed(() => {
    if(isFileImage.value) {
        return null
    }

    return props.file.file_name
})
</script>

<style scoped>

</style>
